import React, { Suspense } from "react";
import { ConfigProvider, theme } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
	BrowserRouter as Router,
	Route,
	Switch,
	withRouter,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ResetPassword from "./containers/Account/ResetPasswordPage.js";
import EmailConfirmation from "./containers/Account/EmailConfirmationPage.js";
import ForgotPassword from "./containers/Account/ForgotPasswordPage.js";
import Login from "./containers/Account/Login.js";
import DicomViewerPage from "./containers/DicomViewerPage";
import DicomDownloadPage from "./containers/DicomDownloadPage";
import { ExamRefList, ExamReview } from "./containers/radPortal";
import PatientEditor from "./containers/Patient/Patient.js";
import { DashboardLayout } from "./layouts";
import "./utilities/string-en";
import DicomViewerShare from "./containers/DicomViewerShare";
import LoginShare from "./containers/LoginShare";
import ShortURLShare from "./containers/ShortURLShare";

const Layout = withRouter(({ location, children }) => {
	document.title =
		"RefApp - " +
		location.pathname
			.replace("/", " - ")
			.replace("/", " - ")
			.replace("/", " - ")
			.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
	//check if apply master layout

	return location.pathname === "/" ||
		location.pathname.toLowerCase().startsWith("/account") ||
		location.pathname.toLowerCase().startsWith("/img/") ? (
		children
	) : (
		<DashboardLayout>{children}</DashboardLayout>
	);
});

function App() {
	console.info("inicio refapp");
	const LoadingModal = React.lazy(() => import("./LoadingModal"));
	const AuthControl = React.lazy(() => import("./AuthControl"));
	const PersonalSettings = React.lazy(
		() => import("./containers/SetupUser/EditorPersonalSettings"),
	);
	const UserSettings = React.lazy(
		() => import("./containers/SetupUser/UserSettings"),
	);

	return (
		<ErrorBoundary>
			<ConfigProvider
				theme={{
					algorithm: theme.compactAlgorithm,
					token: {
						colorPrimary: "#F4801A",
					},
				}}
			>
				<div
					className="App"
					id="body"
					style={{ height: "100vh", overflow: "hidden" }}
				>
					<Router>
						<Suspense fallback={<div></div>}>
							<AuthControl />
							<LoadingModal />
							<ToastContainer />
							<Switch>
								<Layout>
									<Route exact path="/account/login" component={Login} />
									<Route
										exact
										path="/dcm-download"
										component={DicomDownloadPage}
									/>
									<Route
										exact
										path="/img/:tid/:uid/:mod"
										component={DicomViewerPage}
									/>
									<Route
										exact
										path="/account/forgot-password"
										component={ForgotPassword}
									/>
									<Route
										exact
										path="/account/reset-password/:token"
										component={ResetPassword}
									/>
									<Route
										exact
										path="/account/email-confirm"
										component={EmailConfirmation}
									/>
									<Route
										exact
										path="/account/email-confirm/:token"
										component={EmailConfirmation}
									/>
									<Route exact path="/exam-review" component={ExamReview} />
									<Route exact path="/exam-review/:id" component={ExamReview} />
									<Route exact path="/exam-ref-list" component={ExamRefList} />
									<Route exact path="/patient/:id" component={PatientEditor} />
									<Route exact path="/patient/" component={PatientEditor} />
									<Route
										exact
										path="/account/share/:id/:token"
										component={DicomViewerShare}
									/>
									<Route
										exact
										path="/account/loginshare/:token"
										component={LoginShare}
									/>
									<Route
										exact
										path="/account/shortshare/:id/:token"
										component={ShortURLShare}
									/>
									{/* Sidenav */}
									<Route exact path="/configuration" component={UserSettings} />
									<Route
										exact
										path="/configuration/personal"
										component={PersonalSettings}
									/>
								</Layout>
							</Switch>
						</Suspense>
					</Router>
				</div>
			</ConfigProvider>
		</ErrorBoundary>
	);
}

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		console.error(error);
		console.error(errorInfo);
		//logErrorToMyService(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<div>
					<h1>
						Unexpected error, please <a href="/">click here</a>
					</h1>
					<h1>Error details:</h1>
					<div>{this.state.error.toString()}</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export default App;
